<section class="participate-section">
  <div class="container">
    <div class="row align-items-center">
      <!-- Left Column: Includes Content, Steps, and Button -->
      <div class="col-lg-8 col-md-12">
        <div class="participate-content">
          <h1 class="participate-title">ABOUT THE WORKSHOP PROGRAMME</h1>
          <p class="participate-desc">
            The workshop programme is open to students across all disciplines,
            not limited to computer science or engineering. No prior AI or
            coding experience is required. Sessions are structured to be
            accessible to all faculties
          </p>
        </div>

        <div class="flex-cards-container">
          <div class="action-card" *ngFor="let step of steps" [title]="step.title">
            <div class="card-inner-content">
              <div class="logo-box">
                <img [src]="step.logo" class="card-logo" [alt]="step.title" />
              </div>
              <span class="card-label" [title]="step.title">{{ step.title }}</span>
            </div>

            <!-- <div class="chevron-box">
              <svg
                xmlns="http://w3.org"
                width="14"
                height="14"
                fill="currentColor"
                class="bi bi-chevron-right"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                />
              </svg>
            </div> -->
          </div>
        </div>  
<div class="pt-3 mt-3 d-flex gap-1 flex-wrap justify-content-center justify-content-md-start">
  <div class="d-flex flex-nowrap border border-black rounded-3 align-items-center">
    <button
      class="ps-4 pe-2 py-2 bg-transparent border-0 text-black text-nowrap fw-semibold d-flex align-items-center"
      (click)="navigateToPDFLink()"
    >
      Call for Proposals
    </button>
    <img 
      src="images/praposalBlack.svg" 
      width="20" 
      height="20" 
      class="me-3" 
      alt="AIKosh Presenter"
    />
  </div>
</div>


      </div> <!-- Correctly closing the left col-lg-6 column -->

      <!-- Right Column: Student Graphics Layer -->
      <div
        class="col-lg-4 col-md-12 mt-4 mt-lg-0 d-flex justify-content-center justify-content-lg-end"
      >
        <div class="participate-image-wrapper text-end w-100">
          <img
            [src]="participateAssets.participateImage"
            class="student-img img-fluid ms-auto"
            alt="Main illustration graphic"
          />
        </div>
      </div>
    </div>
  </div>
</section>